export default class CambioClave {
    constructor(
        public codUsuario: string = null,
        public claveAnterior: string = null,
        public claveActual: string = null
    ) {}
}